import { onPlayAudioBackground, onStopAudioBackground } from '@/services/media-manager.service'
import { useEffect, useState } from 'react'
import AudioPlayer from './AudioPlayer'

export default function BackgroundAudio({ className }: { className?: string }) {
  const [backgroundAudioSrc, setBackgroundAudioSrc] = useState<string | null>(null)
  const [backgroundAudio, setBackgroundAudio] = useState<React.ReactNode>(null)

  useEffect(() => {
    const handlePlayAudioBackground = ({ src, time }: { src: string; time: number }) => {
      if (backgroundAudioSrc === src) return

      setBackgroundAudio(
        <FloatingAudioPlayer key={src + time} src={src} time={time} className={className} />
      )
      setBackgroundAudioSrc(src)
    }

    const handleStopAudioBackground = () => {
      setBackgroundAudio(null)
    }

    const unsubPlay = onPlayAudioBackground(handlePlayAudioBackground)
    const unsubStop = onStopAudioBackground(handleStopAudioBackground)

    return () => {
      unsubPlay()
      unsubStop()
    }
  }, [])

  return backgroundAudio
}

function FloatingAudioPlayer({
  src,
  time,
  className
}: {
  src: string
  time?: number
  className?: string
}) {
  return <AudioPlayer src={src} className={className} startTime={time} isMinimized />
}
